import React, { Component } from 'react';
import {
  Segment,
  Label,
  Button,
  Icon,
  Dropdown,
  Rating,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { Media } from 'src/utils/Media';
import Avatar from '../avatar/avatar';
import SocialProfileLinks from '../../containers/readers/components/socialProfileLinks';
import UserReviewsModal from './userReviewsModal';
import i18n from 'src/utils/i18n/i18n';

class UserBadge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReviewsModal: false,
    };
  }

  toggleShowAllGenres = () =>
    this.setState(prevState => ({
      showAllGenres: !prevState.showAllGenres,
    }));

  handleInviteClick = () => {
    if (this.props.onInvite) {
      this.props.onInvite();
    }
  };

  handleReviewsClick = () => {
    this.setState({ showReviewsModal: true });
  };

  handleCloseReviewsModal = () => {
    this.setState({ showReviewsModal: false });
  };

  render() {
    const { t, user, showInviteButton = true, locked = false } = this.props;
    const { showAllGenres, showReviewsModal } = this.state;
    if (!user) {
      return null;
    }
    // Free plans see the pool as a teaser: identity (name, photo, socials)
    // blurred, everything that sells it (genres, rating, languages, bio) shown.
    const blurStyle = locked
      ? { filter: 'blur(5px)', userSelect: 'none', pointerEvents: 'none' }
      : undefined;
    return (
      <React.Fragment>
        <Segment
          key={user._id}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
          }}
          content={
            <React.Fragment>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{ width: 50, marginRight: 15, ...blurStyle }}>
                  <Avatar
                    name={user.displayName}
                    userId={user._id}
                    src={user.photoUrl}
                    diameter={50}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'flex-start',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <strong style={blurStyle}>
                          <Avatar
                            name={user.displayName}
                            userId={user._id}
                            nameOnly
                          />
                        </strong>
                        {user.averageRating && (
                          <div
                            style={{
                              marginLeft: 10,
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Rating
                              icon="star"
                              rating={user.averageRating}
                              maxRating={5}
                              disabled
                              size="mini"
                            />
                            <span
                              style={{
                                fontSize: '0.8em',
                                marginLeft: 5,
                                color: '#0084ff',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                textDecorationStyle: 'dotted',
                              }}
                              onClick={this.handleReviewsClick}
                              title={t('ClickToSeeAllReviews')}
                            >
                              ({user.reviewCount})
                            </span>
                          </div>
                        )}
                      </div>
                      <div style={{ marginTop: 2 }}>
                        {user.preferredLanguages &&
                          user.preferredLanguages.map(language => (
                            <Label
                              key={language}
                              basic
                              size="mini"
                              content={
                                language.nativeName
                                  ? language.nativeName
                                  : language
                              }
                            />
                          ))}
                      </div>
                    </div>
                    {user.socialProfiles && (
                      <span style={{ marginLeft: 8, ...blurStyle }}>
                        <SocialProfileLinks
                          socialProfiles={user.socialProfiles}
                          style={{ marginTop: '0px' }}
                        />
                      </span>
                    )}
                  </div>
                  <div>
                    {user.preferredGenres &&
                      user.preferredGenres.map((genre, index, array) => {
                        const showMoreLimit = window.innerWidth > 450 ? 3 : 1;
                        if (!showAllGenres) {
                          // toggle show all if there are more genres to show
                          if (
                            index === showMoreLimit &&
                            array.length > showMoreLimit + 1
                          ) {
                            return (
                              <Icon
                                key="toggle"
                                link
                                name="ellipsis horizontal"
                                onClick={this.toggleShowAllGenres}
                              />
                            );
                          }
                          // stop rendering labels if not showing all
                          if (index > showMoreLimit - 1) {
                            return null;
                          }
                        }
                        return (
                          <Label
                            size="small"
                            key={genre}
                            circular
                            content={genre}
                            style={{ marginTop: 2 }}
                          />
                        );
                      })}
                  </div>
                  <p
                    style={{
                      paddingTop: 5,
                      whiteSpace: 'pre-line',
                      hyphens: 'auto',
                      wordBreak: 'break-word',
                    }}
                  >
                    {user.bio}
                  </p>
                </div>
                {showInviteButton && [
                  <Media
                    as={Button}
                    color="orange"
                    greaterThan="mobile"
                    style={{
                      marginLeft: 'auto',
                      wordBreak: 'normal',
                      whiteSpace: 'pre',
                    }}
                    content={
                      locked
                        ? t('UpgradeToInvite', 'Upgrade to invite')
                        : t('Invite')
                    }
                    icon={locked ? 'lock' : 'mail'}
                    onClick={this.handleInviteClick}
                    key="large-button"
                  />,
                  <Media
                    as={Dropdown}
                    at="mobile"
                    direction="left"
                    style={{ marginLeft: 'auto' }}
                    icon="ellipsis vertical"
                    key="small-button"
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item
                        icon={locked ? 'lock' : 'mail'}
                        text={
                          locked
                            ? t('UpgradeToInvite', 'Upgrade to invite')
                            : t('Invite')
                        }
                        onClick={this.handleInviteClick}
                      />
                    </Dropdown.Menu>
                  </Media>,
                ]}
              </div>
            </React.Fragment>
          }
        />
        <UserReviewsModal
          open={showReviewsModal}
          onClose={this.handleCloseReviewsModal}
          user={user}
        />
      </React.Fragment>
    );
  }
}

export default withTranslation()(UserBadge);
